export enum ActionTypes {
    FETCH_COUNT = "FETCH_COUNT",
    FETCH_COUNT_SUCCESS = "FETCH_COUNT_SUCCESS",
    FETCH_COUNT_FAIL = "FETCH_COUNT_FAIL"
}